import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import DialogPopup from "../components/DialogPopup";
import ContactEmail from "../components/contactEmail";
import MobileMenu from "../components/MobileMenu";
import Zoom from 'react-medium-image-zoom'
class MateriauxInertes extends Component {
    render() {
        let data = [
            {
                pageLink: "service-details-left-sidebar",
                img: "21_sablemixte.jpg",
                iconClass: "flaticon-002-welding",
                serviceTitle: "Sable mixte recyclé",
                serviceSubtitle:
                    ""
            },
            {
                pageLink: "service-details-left-sidebar",
                img: "17-sablescalpage.jpg",
                iconClass: "flaticon-004-walkie-talkie",
                serviceTitle: "Sable de scalpage 0/8",
                serviceSubtitle:
                    ""
            },
            {
                pageLink: "service-details-left-sidebar",
                img: "16-sablescalapage040.jpg",
                iconClass: "flaticon-015-cart",
                serviceTitle: "0/40 de scalpage",
                serviceSubtitle:
                    ""
            },
            {
                pageLink: "service-details-left-sidebar",
                img: "18-terrescalpe.jpg",
                iconClass: "flaticon-010-tank-1",
                serviceTitle: "Terre de scalpage",
                serviceSubtitle:
                    ""
            },
            // {
            //     pageLink: "service-details-left-sidebar",
            //     img: "20_0-20.png",
            //     iconClass: "flaticon-010-tank-1",
            //     serviceTitle: "0/20 de scalpage béton",
            //     serviceSubtitle:
            //         ""
            // },
            {
                pageLink: "service-details-left-sidebar",
                img: "19-0-40.jpg",
                iconClass: "flaticon-010-tank-1",
                serviceTitle: "0/31.5 concassé",
                serviceSubtitle:
                    ""
            },
            {
                pageLink: "service-details-left-sidebar",
                img: "15-0-80concasse.jpg",
                iconClass: "flaticon-010-tank-1",
                serviceTitle: "0/80 concassé",
                serviceSubtitle:
                    ""
            },
            {
                pageLink: "service-details-left-sidebar",
                img: "3180concasse.jpg",
                iconClass: "flaticon-010-tank-1",
                serviceTitle: "31.5/80 concassé",
                serviceSubtitle:
                    ""
            }
        ];

        let Datalist = data.map((val, i) => {
            return (
                <div
                    className="col-lg-4 col-md-6 col-12 section-space--bottom--30"
                    key={i}
                >
                    <div className="service-grid-item">
                        <div className="service-grid-item__image" style={{ marginBottom: 30 }}>
                            <div className="service-grid-item__image-wrapper">
                                <Zoom>
                                    <img
                                        src={`assets/img/recyclagematinertes/${val.img}`}
                                        className="img-fluid"
                                        alt="Service Grid"
                                    />
                                </Zoom>
                            </div>
                        </div>
                        <div className="service-grid-item__content">
                            <h3 className="title">
                                {val.serviceTitle}
                            </h3>
                            <p className="subtitle">{val.serviceSubtitle}</p>
                            <DialogPopup
                                trigger={<span style={{ cursor: "pointer", textDecoration: "underline" }}>Demander la fiche technique</span>}
                            >
                                <ContactEmail prefillMessage={`Bonjour, je souhaite recevoir la fiche technique de « ${val.serviceTitle} ». Merci !`} />
                            </DialogPopup>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div>
                <NavBar />
                <div
                    className="breadcrumb-area breadcrumb-bg"
                    style={{
                        backgroundImage: `url(assets/img/backgrounds/20250305_092607.jpg)`
                    }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="page-banner text-center">
                                    <h1>Recyclage de matériaux inertes</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of breadcrumb area  ====================*/}

                <div className="page-wrapper section-space--inner--60">
                    {/*Service section start*/}
                    <div className="service-section">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-12 order-1 order-lg-2">
                                    <div className="service-details">
                                        <div className="content section-space--top--30">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="section-title-area text-center section-space--bottom--50">
                                                    <h2 className="section-title">Nos produits</h2>
                                                    <p>
                                                        Nous avons pour l’ensemble de nos produits des fiches techniques.
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="service-item-wrapper">
                                        <div className="row">{Datalist}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <br></br>
                        <div className="section-title-area text-center" id="reception" style={{ marginTop: 30 }}>
                            <h2 className="section-title section-space--bottom--50">À venir chez SEM : une centrale de traitement</h2>
                        </div>
                        <div className="blog-details col-12">
                            <div className="blog-inner">
                                <div className="content">
                                    <Zoom>
                                        <img
                                            src={`assets/img/recyclagematinertes/IMG_20230209_090138.jpg`}
                                            className="img-fluid"
                                            alt="Service Grid"
                                        />
                                    </Zoom>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Service section end*/}
            </div>

                {/* Brand logo */ }
        {/* <BrandLogoSlider background="grey-bg" /> */ }

        {/* Footer */ }
        <Footer />

        {/* Mobile Menu */ }
        <MobileMenu />
            </div >
        );
    }
}

export default MateriauxInertes;
